import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Divider,
  Heading,
  VStack,
} from '@chakra-ui/react'
import { useQuery } from 'react-query'
import { useAuth } from '../../context/AuthContext'
import { User } from '../../Interfaces/users'
import { api } from '../../services/api'
import EditPassword from './password-edit'
import EditUser from './user-edit'

export default function UserProfile({ match }: any) {
  const { user } = useAuth()
  const routeId = match?.params?.id as string | undefined
  const effectiveId = routeId && routeId !== ':id' ? routeId : user?.id ? String(user.id) : ''

  const { data: fetchedUser } = useQuery(
    ['user', effectiveId],
    async () => {
      const { data } = await api.get<User>(`users/${effectiveId}`)
      return data
    },
    { enabled: Boolean(effectiveId) },
  )

  return (
    <Box flex="1" borderRadius="8" bg="gray.800" p="8">
      <Heading size="lg" fontWeight="normal">
        Seu Perfil
      </Heading>

      <Divider my="6" borderColor="gray.700" />

      <VStack spacing="4" align="stretch">
        <Accordion pt="4" allowMultiple defaultIndex={[0]}>
          <AccordionItem borderBottom="none">
            <AccordionButton _focus={{ boxShadow: 'none' }}>
              <Box flex="1" textAlign="left">
                Editar Usuario
              </Box>

              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel p="6">
              <EditUser id={effectiveId} user={fetchedUser as User} />
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem borderBottom="none">
            <AccordionButton _focus={{ boxShadow: 'none' }}>
              <Box flex="1" textAlign="left">
                Alterar sua senha
              </Box>

              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel p="6">
              <EditPassword />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </VStack>
    </Box>
  )
}
